module.exports = __webpack_public_path__ + "static/media/typing.fb749a2f.gif";